import * as path from "path-browser";
import { LIB_PREFIX } from "../../TypesAndIdentifiers";

export default class ContentPaths {
  public lib: string;
  public launcher: string;
  public frameworks: string;
  public res: {
    sounds: string;
    fonts: string;
    locale: string;
    root: string;
    graphics: string;
  };
  public globalRes: {
    sounds?: string;
    graphics?: string;
    fonts?: string;
    root?: string;
  };
  protected domain = "";

  constructor(id: string, public libRoot: string) {
    this.setLauncherPath();
    this.setDefaultResPaths();
  }

  private setLauncherPath(): void {
    this.libRoot = path.join(this.domain, this.libRoot);
    this.launcher = path.join(this.domain, LIB_PREFIX, "launcher");
    this.frameworks = path.join(this.domain, "frameworks");
  }

  private setDefaultResPaths(): void {
    this.res = this.res || {};
    this.res.root = path.join(this.libRoot, "common", "res/");
    this.res.sounds = path.join(this.res.root, "sounds/");
    this.res.graphics = path.join(this.res.root, "graphics/ldpi/");
    this.res.fonts = path.join(this.res.root, "fonts/");
    this.res.locale = path.join(this.res.root, "locale/");
  }
}
